import React from 'react';
import { Users, Lightbulb, Bot, Video, Calendar, FileText, UserPlus, Globe } from 'lucide-react';
export const MembershipBenefits = () => {
  const benefits = [{
    title: 'Mastermind Sessions',
    description: 'Live idea feedback & strategy polishing',
    icon: <Lightbulb size={24} data-id="element-501" data-mp="2vbwx6yuqgtsb" />
  }, {
    title: 'Project Handholding',
    description: 'Step-by-step guidance',
    icon: <Users size={24} data-id="element-502" data-mp="2m95imq6k9hwg" />
  }, {
    title: 'AI Tools Catalogue',
    description: 'Curated tools + playbooks',
    icon: <Bot size={24} data-id="element-503" data-mp="2hi5lpkxfyzty" />
  }, {
    title: 'Virtual Networking Salons',
    description: 'Free & unlimited for members',
    icon: <Video size={24} data-id="element-504" data-mp="2ckdvqwgcxnse" />
  }, {
    title: 'Discounted Access to Live Events',
    description: 'Special pricing for Inner Circle members',
    icon: <Calendar size={24} data-id="element-505" data-mp="27iojjdhef42q" />
  }, {
    title: 'Exclusive Resource Hub',
    description: 'Templates & toolkits',
    icon: <FileText size={24} data-id="element-506" data-mp="1yk343r784566" />
  }, {
    title: 'Mentorship & Expert Access',
    description: 'Group coaching & hot-seat sessions',
    icon: <UserPlus size={24} data-id="element-507" data-mp="3dlh29jmdpkcl" />
  }, {
    title: 'Visibility & Collaboration Opportunities',
    description: 'Connect with other members',
    icon: <Globe size={24} data-id="element-508" data-mp="3if1uev1ajk3v" />
  }];
  return <section className="py-16 border-b border-gray-200" data-id="element-509" data-mp="33ouiyz9pb1co">
      <div className="container mx-auto px-4" data-id="element-510" data-mp="33m9hwch88pfz">
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-12" data-id="element-511" data-mp="38mnrhyyh87g4">
          Membership Benefits
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-512" data-mp="8x7mmzszncr">
          {benefits.map((benefit, index) => <div key={index} className="border-2 border-gray-300 rounded-lg p-6 flex flex-col items-center text-center" data-id="element-513" data-mp="566xg3r3u114" data-mpi={index}>
              <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mb-4" data-id="element-514" data-mp="3neo6h15duub3">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-515" data-mp="2bvlh51jgtm2u">
                {benefit.title}
              </h3>
              <p className="text-gray-600" data-id="element-516" data-mp="2fwnh5kl7i25v">{benefit.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
};